import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, Card, Button, Row, Spinner } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import SessionHelper from "../../../helpers/SessionHelper";
import StaffLogin from "../login/StaffLogin";
import WellReportService from "../../../api-service/WellReportService";
import {
  updateWellTestDetails,
  incrementSubmittedCount,
} from "../../../configurations/redux-configurations/actions/wellTestAction";
import _ from "lodash";
import StorageHelper from "../../../helpers/StorageHelper";
import {
  INCOMING_TOKEN_HAS_EXPIRED,
  PLEASE_TRY_AGAIN_LATER,
  YOU_ARE_OFFLINE,
  SOME_FORMS_NOT_SUBMITTED,
  ERROR_SUBMITTING_WELL_TEST_FORM,
} from "../../../configurations/MessageConstants";
import {
  STAFF_LOGGED_IN_USER,
  STAFF_SESSION_EXPIRED,
} from "../../../configurations/Constants";
import { StatusCodes } from "../../../configurations/status-codes";

function StatusBar(props) {
  const dispatch = useDispatch();
  const FormsValue = useSelector((state) => state.wellTest.forms);
  const FormsSubmitted = useSelector((state) => state.wellTest.formsSubmitted);

  const [showStaffLogin, setShowStaffLogin] = useState(false);
  const [formError, setFormError] = useState(false);
  const [formSync, setFormSync] = useState(false);
  const [isDisconnected, setIsDisconnected] = useState(false);

  const closeLoginModal = () => {
    setShowStaffLogin(false);
    setFormSync(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!navigator.onLine) return;
      const current_staff = StorageHelper.getItem(STAFF_LOGGED_IN_USER);
      if (current_staff && !formSync) handleSubmitSavedForms(false);
    }, 10000);
    return () => clearInterval(interval);
  }, [FormsValue]);

  const handleConnectionChange = async (e) => {
    const condition = navigator.onLine ? "online" : "offline";
    if (condition !== "online") {
      toast.warn(
        <div>
          {YOU_ARE_OFFLINE}
          <br />
          {PLEASE_TRY_AGAIN_LATER}
        </div>
      );
      setIsDisconnected(true);
      return;
    }
    setIsDisconnected(false);
    await handleLoginConfirmation();
  };

  const handleLoginConfirmation = async () => {
    setFormError(false);
    const current_staff = StorageHelper.getItem(STAFF_LOGGED_IN_USER);
    if (!current_staff) {
      setShowStaffLogin(true);
      return;
    }
    await handleSubmitSavedForms(true);
  };

  const CheckStaffLoggedIn = async (value) => {
    if (!value) return;
    await handleSubmitSavedForms(true);
  };

  const handleSubmitSavedForms = async (value) => {
    let showToasts = value;
    setFormSync(true);
    if (FormsValue.length === 0) {
      setFormSync(false);
      if (showToasts) props.NoSavedFroms(true);
    } else {
      let savedForms = FormsValue;
      let savedFormsInChunks = _.chunk(savedForms, 5);
      savedFormsInChunks.forEach(async (payload) => {
        try {
          await WellReportService.submitWellTestForm({
            submissions: payload,
          });
          payload.forEach((item) => {
            savedForms = FilterSubmittedEntries(savedForms, item.form_id);
          });
          dispatch(incrementSubmittedCount(payload.length));
          dispatch(updateWellTestDetails(savedForms));
          if (savedForms.length === 0) {
            setFormSync(false);

            if (showToasts) props.FormSubmitted(true);
          }
        } catch (error) {
          console.error(ERROR_SUBMITTING_WELL_TEST_FORM, error);
          if (!error.response) {
            setIsDisconnected(true);
            setFormSync(false);
            setFormError(true);

            if (showToasts) {
              toast.warn(
                <div>
                  {YOU_ARE_OFFLINE}
                  <br />
                  {PLEASE_TRY_AGAIN_LATER}
                </div>
              );
            }
            setFormError(false);
          } else {
            setFormError(true);
            setFormSync(false);

            let responseData = error.response.data;
            if (
              error.response.status === StatusCodes.UNAUTHORIZED &&
              responseData.message.includes(INCOMING_TOKEN_HAS_EXPIRED)
            ) {
              StorageHelper.setItem(STAFF_SESSION_EXPIRED, true);
              SessionHelper.cleanUpStorageKeys();
              setShowStaffLogin(true);
            } else if (error.response.status === StatusCodes.BAD_REQUEST) {
              toast.warn(
                <div>
                  {SOME_FORMS_NOT_SUBMITTED}
                  <br />
                  {PLEASE_TRY_AGAIN_LATER}
                </div>,
                { className: "toast-container-warning" }
              );
              setFormError(false);
            }
          }
        }
      });
    }
  };

  const FilterSubmittedEntries = (arr, id) => {
    const objWithIdIndex = arr.findIndex((obj) => obj.id === id);
    arr.splice(objWithIdIndex, 1);
    return arr;
  };

  return (
    <div>
      {formError ||
        (isDisconnected && (
          <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        ))}

      <Card
        bg="dark"
        className=" card text-white justify-content-center align-items-center d-flex"
      >
        <Card.Body className="pb-0 ps-0 pe-0">
          <Row className="m-0">
            <Col className="flex-column align-items-center d-flex ps-1 pe-1">
              <Card.Text className="mt-1 mb-1">Submitted</Card.Text>
              <Card.Title>{FormsSubmitted ? FormsSubmitted : 0}</Card.Title>
            </Col>
            <Col className="flex-column align-items-center d-flex ps-1 pe-1">
              <Card.Text className="mt-1 mb-1">Pending</Card.Text>
              <Card.Title>{FormsValue ? FormsValue.length : 0}</Card.Title>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Button
        className="status-bar-btn"
        disabled={formSync}
        variant="primary"
        onClick={(e) => handleConnectionChange(e)}
      >
        {formSync ? (
          <div>
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            <span>Processing...</span>
          </div>
        ) : (
          "Submit Forms"
        )}
      </Button>
      <StaffLogin
        showStaffLogin={showStaffLogin}
        closeLoginModal={closeLoginModal}
        CheckStaffLoggedIn={(value) => CheckStaffLoggedIn(value)}
      />
    </div>
  );
}

export default StatusBar;
